import React from 'react'

export default function About() {
    return (
        <>
       
        <div id='abou' className='about'>
            <div className='container'>

           <div className="Common">
               
            <h1 className='main-heading'>
                About Me
            </h1>
               <p className='main-content'>
                   Lorem ipsum dolor sit, amet consectetur adipisicing elit. Hic in laboriosam illo cupiditate dicta. Pariatur.
               </p>
               <div className='commonBorder'></div>
            </div>
            <div className='row h-650 text-cen'>
              <div className='col-6'>
                  <div className='about-img'></div>
              </div>
              <div className='col-6'>
                  <div className="aboutinfo">
                      <h1 className='about-head'>Hi There</h1>
                      <p className="aboutin1">Lorem ipsum dolor sit amet consectetur adipisicing elit. Perferendis optio fugit maxime, a totam neque.</p>
                      <p className="aboutin2">Lorem ipsum dolor, sit amet consectetur adipisicing elit. Cumque, officia!</p>
                      <div className="about-con">
                          <div className='row'>
                              <div className="col6 mar">
                                  <strong>Name :</strong>
                                  <p>Naimul Islam</p>
                              </div>
                              <div className="col6 mar">
                                  <strong>Email  :</strong>
                                  <p>naiem11972454@gmail.com</p>
                              </div>
                              </div>
                              <div className='row'>
                              <div className="col6 mar">
                                  <strong>Phone :</strong>
                                  <p>01754812454</p>
                              </div>
                              <div className="col6 mar">
                                  <strong>Linkedin :</strong>
                                  <p>naiem_123</p>
                              </div>
                          </div>
                      </div>
                  </div>
              </div>
            </div>
               </div> 
        </div>
        </>
    )
}
